import * as React from 'react'

const SvgArrow = ({ ...props }) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" fill="none">
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={5}
      d="M2 2.848h35v35M2 37.848l35-35"
    />
  </svg>
)

export default SvgArrow
